<template>
  <div
    class="rounded-3xl bg-white/10 p-8 shadow-xl transition duration-200 hover:-translate-y-1 hover:bg-white/[0.14]"
  >
    <p class="text-sm font-bold text-slate-400">
      {{ label }}
    </p>

    <h3 class="mt-3 text-2xl font-black">
      {{ title }}
    </h3>

    <p class="mt-4 text-slate-300">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",

  props: {
    label: String,
    title: String,
    description: String,
  },
};
</script>
